import { RestSchemas } from '@/contexts/QueryProvider'

export type ApplicationMarketingCard = RestSchemas['Messages.Landing.ApplicationMarketingCard']

/** Pin specific apps in this order. Leave empty to use the Live / distinct-subtitle heuristic. */
export const FEATURED_APP_IDS: number[] = []

const FEATURED_LIMIT = 6

function hasDistinctSubtitle(app: ApplicationMarketingCard) {
  const title = app.card.title?.trim() ?? ''
  const subtitle = app.card.subtitle?.trim() ?? ''
  return subtitle.length > 0 && subtitle !== title
}

function featuredScore(app: ApplicationMarketingCard) {
  return (hasDistinctSubtitle(app) ? 2 : 0) + (app.picture_url ? 1 : 0)
}

export function selectFeaturedApps(apps: ApplicationMarketingCard[], limit = FEATURED_LIMIT) {
  if (FEATURED_APP_IDS.length > 0) {
    const byId = new Map(apps.map((app) => [app.app_id, app]))
    return FEATURED_APP_IDS.map((id) => byId.get(id))
      .filter((app): app is ApplicationMarketingCard => Boolean(app))
      .slice(0, limit)
  }

  return [...apps]
    .filter((app) => app.tag === 'Live')
    .sort((a, b) => featuredScore(b) - featuredScore(a))
    .slice(0, limit)
}
